import axios from "axios";
import camelize from "camelize";

// Los endpoints de Stripe viven en usa-web-api (Stripex), que es donde está la
// clave secreta. Se llaman con el token del admin, igual que StripePaymentModal.
const baseUrl = () => `${process.env.VUE_APP_WEB_API}/stripex`;

// Pagos Stripe vinculados a la orden (incluye los de la orden padre). Sólo el
// vínculo local; el detalle real se pide con getStripePayment.
export function getOrderStripePayments(token, orderNumber) {
  return axios
    .get(`${baseUrl()}/admin_order_stripe_payments`, {
      params: { order_number: orderNumber },
      headers: { Authorization: token }
    })
    .then(res => camelize(res.data));
}

// Detalle en vivo desde Stripe (montos, cargo, reembolsos). context indica
// desde dónde se abre: { orderNumber } o { posTransactionId }.
export function getStripePayment(token, context, paymentIntentId) {
  return axios
    .get(`${baseUrl()}/admin_payment/${encodeURIComponent(paymentIntentId)}`, {
      params: {
        order_number: context.orderNumber || undefined,
        pos_transaction_id: context.posTransactionId || undefined
      },
      headers: { Authorization: token }
    })
    .then(res => camelize(res.data));
}

// Reembolso total (full=true) o parcial (amount). expectedRefundable son los
// centavos reembolsables que mostró el modal: si en Stripe ya no coinciden el
// backend responde 409 con el pago actualizado.
export function refundStripePayment(token, refund) {
  return axios
    .post(
      `${baseUrl()}/admin_refund`,
      {
        order_number: refund.orderNumber || null,
        pos_transaction_id: refund.posTransactionId || null,
        payment_intent_id: refund.paymentIntentId,
        full: refund.full,
        amount: refund.amount,
        expected_refundable: refund.expectedRefundable,
        reason: refund.reason || null,
        note: refund.note || "",
        idempotency_key: refund.idempotencyKey,
        return_id: refund.returnId || null
      },
      { headers: { Authorization: token } }
    )
    .then(res => camelize(res.data));
}
